import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Apollo, gql} from 'apollo-angular';
import {ToastrService} from 'ngx-toastr';
import {Subscription} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ErrorService} from '../shared/services/error.service';
import {
  Instructions_getInstructionFiles,
  Instructions_getInstructionFiles_instructionFiles,
} from './__generated__/Instructions_getInstructionFiles';

const GET_INSTRUCTION_FILES = gql`
  query Instructions_getInstructionFiles {
    instructionFiles {
      id
      title
      subtitle
      textFileUrl
    }
  }
`;

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss'],
})
export class InstructionsComponent implements OnInit, OnDestroy {
  loading = false;
  instructionFiles: Instructions_getInstructionFiles_instructionFiles[] = [];
  private subscriptions: Subscription[] = [];

  constructor(
    private apollo: Apollo,
    private errorHandler: ErrorService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.apollo
        .watchQuery<Instructions_getInstructionFiles>({
          query: GET_INSTRUCTION_FILES,
          notifyOnNetworkStatusChange: true,
        })
        .valueChanges.pipe(
          catchError(error => this.errorHandler.handleApollo(error))
        )
        .subscribe(({data, error, loading}) => {
          this.loading = loading;
          if (error) {
            this.toastr.error(error.message);
          }
          this.instructionFiles = data.instructionFiles;
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
